
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import {RoleProps} from "types/props-obj/RoleProps";

const initialState: RoleProps = {
    apiEndPoint: "role",
    pageLimit: 5,
    pageNumber: 1,
    isOpen: false,
    list: [],
    item: null,
    error: null,
    alertPopup: false
};

const role = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all Item list
        getList(state, action) {
            state.list.push(action.payload);
            state.list = state.list.filter((liste) => liste.id !== 0);
            state.isLoading=false;
        },
        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        },
        openToggle(state, action) {

            state.isOpen = action.payload.isOpen;
        },
        // get Item details
        setItem(state, action) {
            state.item = action.payload;
            state.isLoading=false;
        },
        removeItem(state) {
            state.item =null;
            state.isLoading=false;
        },

        // GET Items
        setItemsSuccess(state, action) {
            
            state.list = action.payload;
            state.isLoading=false;
        },

        // ADD Item
        addItemSuccess(state, action) {
            state.list = [...state.list,action.payload];
            state.isLoading=false;
        },

        // EDIT Item
        editItemSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id === action.payload.id);
            state.item=action.payload;
            state.list[foundIndex] = action.payload;
            state.isLoading=false;
        },

        deleteItemSuccess(state, action) {
            state.list = state.list.filter((item) => item.id !== action.payload);
            state.isLoading=false;
        },



        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },

        setLoading(state, action) {
            state.isLoading = action.payload;
        },
    }
});


export default role.reducer;

function getApiEndPoint(){
    return store.getState().role.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setPageLimit,setApiEndPoint,removeItem } = role.actions;
export function getList(params:any={}) {
    return async () => {
        dispatch(role.actions.setLoading(true));
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(role.actions.setItemsSuccess(response.data));
        } catch (error) {
            dispatch(role.actions.hasError(error));
        }
    };
}

export function getItem(id: number | undefined) {
    return async () => {
        dispatch(role.actions.setLoading(true));
        try {
            const response = await axios.get([getApiEndPoint(),  id].join('/'));
            dispatch(role.actions.setItem(response.data));
            dispatch(role.actions.setLoading(false));
        } catch (error) {
            dispatch(role.actions.hasError(error));
        }
    };
}

export function addItem(ls:any) {
    return async () => {
        dispatch(role.actions.setLoading(true));
        try {
            const response = await axios.post(getApiEndPoint(), ls,{headers:{'Content-Type': 'multipart/form-data'}});
            dispatch(role.actions.addItemSuccess(response.data));
            dispatch(role.actions.setLoading(false));
        } catch (error) {
            dispatch(role.actions.hasError(error));
        }
    };
}

export function editItem(id: number | undefined,ls: any) {
    return async () => {
        dispatch(role.actions.setLoading(true));
        try {
            const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
            dispatch(role.actions.editItemSuccess(response.data));
            dispatch(role.actions.setLoading(false));
        } catch (error) {
            dispatch(role.actions.hasError(error));
        }
    };
}

export function deleteItem(id: number | undefined) {
    return async () => {
        dispatch(role.actions.setLoading(true));
        try {
            await axios.delete([getApiEndPoint(),  id].join('/'));
            dispatch(role.actions.deleteItemSuccess(id));
            dispatch(role.actions.setLoading(false));
        } catch (error) {
            dispatch(role.actions.hasError(error));
        }
    };
}